<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachos')">Despachos</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <select-input v-model="form.maquinaria_id" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/4" label="Maquinaria/Vehiculo" required>
            <option v-for="maquinaria in maquinarias" :key="maquinaria.id" :value="maquinaria.id">{{ maquinaria.codigo }} - {{ maquinaria.clase}} - {{maquinaria.placas}}</option>
        </select-input>

        <select-input v-model="form.proyecto" :error="form.errors.proyecto" class="pr-6 pb-8 w-full lg:w-1/4" label="Destino de Proyecto" required>
            <option v-for="proyecto in proyectos" :key="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
        <select-input v-model="form.operador" :error="form.errors.operador" class="pr-6 pb-8 w-full lg:w-1/4" label="Operador" required>
            <option v-for="conductor in conductores" :key="conductor.id">{{ conductor.nombres }} {{ conductor.apellidos }}</option>
        </select-input>
        <select-input v-model="form.gasolinera" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/4" label="Gasolinera" required>
          <option>Cofiza</option>
          <option>Henay</option>
          <option>Trans. Esmeraldas</option>
           <option>Primax</option>
           <option>Super Parada Tsachila</option>
           <option>San Pio</option>
        </select-input>
         
          <text-input v-model="form.numero_comprobante" :error="form.errors.numero_comprobante" class="pr-6 pb-8 w-full lg:w-1/3" label="Nº Comprobante" required/>
          <text-input v-model="form.cantidad_tanqueada" :error="form.errors.cantidad_tanqueada" class="pr-6 pb-8 w-full lg:w-1/3" label="Total Galones" required/>
          <text-input v-model="form.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/3" label="Odometro" required/>
          <text-input v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />
         <br><br><br><br><br><br><br><br><br><br><br>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Despacho</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo: { title: 'Add Despacho' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
     Datepicker
  },
  layout: Layout,
  props: {
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,
    diario: Object


  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        maquinaria_id: null,
        despacho_diarios_id: this.diario.id,
        fecha: null,
        gasoliner: null,
        proyecto: null,
        operador: null,
        numero_comprobante: null,
        numero_documento: '221995',
        cantidad_tanqueada: null,
        odometro_actual: null,
        observacion: null,

      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('despachosdetalle.store'))
    },
  },
}
</script>
